import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BRAND } from "@/data/content";

export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="min-h-screen bg-ng-bg hex-bg text-white">
      {/* Header bar */}
      <header className="border-b border-ng-line bg-ng-bg/80 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3">
            <span className="font-display italic font-black text-2xl tracking-tight leading-none flex">
              <span className="chrome-text">{BRAND.short_split.silver}</span>
              <span className="electric-text">{BRAND.short_split.blue}</span>
            </span>
            <span className="hidden sm:inline-block font-display text-[10px] tracking-[0.35em] text-ng-blue uppercase border-l border-ng-line pl-3">
              Performance
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back"
            className="inline-flex items-center gap-2 text-white/60 hover:text-ng-blue text-xs uppercase tracking-widest font-display font-bold transition-colors"
          >
            <ArrowLeft size={12} /> Back to site
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 md:px-10 pt-16 pb-24">
        <div className="label-eyebrow mb-4">{eyebrow}</div>
        <h1 className="font-display font-bold uppercase text-4xl md:text-6xl tracking-tight leading-[1] text-white">
          {title}
        </h1>
        {updated && (
          <p className="mt-4 text-white/50 text-sm font-display uppercase tracking-widest">
            Last Updated: {updated}
          </p>
        )}

        <div className="mt-12 prose-legal">{children}</div>

        {/* Cross-links */}
        <nav className="mt-16 pt-8 border-t border-ng-line flex flex-wrap gap-6 text-xs uppercase tracking-[0.22em] font-display font-bold">
          <Link to="/privacy" className="text-white/70 hover:text-ng-blue transition-colors">
            Privacy
          </Link>
          <Link to="/terms" className="text-white/70 hover:text-ng-blue transition-colors">
            Terms
          </Link>
          <Link to="/medical-disclaimer" className="text-white/70 hover:text-ng-blue transition-colors">
            Medical Disclaimer
          </Link>
          <a
            href={`mailto:${BRAND.email}`}
            className="ml-auto text-ng-blue hover:text-ng-blueLight transition-colors"
          >
            {BRAND.email}
          </a>
        </nav>
      </main>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-display font-bold uppercase text-xl md:text-2xl tracking-tight text-ng-blue mb-4">
        {title}
      </h2>
      <div className="space-y-4 text-white/75 font-light leading-relaxed">
        {children}
      </div>
    </section>
  );
}

export function Note({ children, tone = "info" }) {
  const border =
    tone === "warning"
      ? "border-yellow-500/40 bg-yellow-500/5"
      : "border-ng-blue/40 bg-ng-blue/5";
  const label =
    tone === "warning" ? "text-yellow-400" : "text-ng-blue";
  return (
    <div className={`border ${border} p-4 md:p-5 mt-4`}>
      <div className={`label-eyebrow ${label} mb-2`}>Note</div>
      <div className="text-white/80 text-sm font-light leading-relaxed">
        {children}
      </div>
    </div>
  );
}
